export default __webpack_public_path__ + "static/media/javascript-es6.27f247d5.jpeg";